import { BENEFIT_ICONS } from "@/constants/landingAssets";

export default function BenefitsSection({ t }) {
  return (
    <section className="py-16 bg-gray-50" data-testid="benefits-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{t.benefits.title}</h2>
        <p className="text-base text-gray-500 max-w-2xl mx-auto mb-10">{t.benefits.subtitle}</p>
        <div className="flex flex-wrap justify-center gap-4 mb-6">
          {t.benefits.items.map((item, i) => {
            const Icon = BENEFIT_ICONS[i];
            return (
              <div key={i} className="flex items-center gap-2 bg-white border border-gray-200 rounded-full px-5 py-2.5 shadow-sm" data-testid={`benefit-${i}`}>
                <Icon className="w-4 h-4 text-[#CDA34F]" />
                <span className="text-sm font-semibold text-gray-700">{item}</span>
              </div>
            );
          })}
        </div>
        <p className="text-sm font-bold text-[#CDA34F] uppercase tracking-wider">{t.benefits.connected}</p>
      </div>
    </section>
  );
}
